import { Vue, Component } from 'vue-property-decorator';

import _ from 'lodash';
import rawData from '@/data/19983881105_e93c2d8279_b.jpg.json';

interface Node {
  Ind: number;
  Type: string;
  Lind: number;
  Rind: number;
  NumLeaves: number;
  R: number;
  G: number;
  B: number;
  Ward: number;
  Sse: number;
  Var: number;
  Std: number;
  NumClusterSamples: number;
  //
  x: number | null;
  y: number | null;
  parentInd: number | null;
  depth: number;
  rowIndex: number;
  leftRightInfoList: string[];
}

interface NodesDict {
  [nodeId: number]: Node;
}

interface Edge {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

@Component({})
export default class BinaryTree extends Vue {
  private readonly basicXInterval: number = 1;
  private readonly nodeYInterval: number = 30;

  private nodes: Node[] = [];
  private edges: Edge[] = [];

  private created() {
    // nodes를 초기화한다.
    this.nodes = _.map(rawData, datum => {
      return {
        Ind: datum.Ind,
        Type: datum.Type,
        Lind: datum.Lind,
        Rind: datum.Rind,
        NumLeaves: datum.NumLeaves,
        R: datum.R,
        G: datum.G,
        B: datum.B,
        Ward: datum.Ward,
        Sse: datum.Sse,
        Var: datum.Var,
        Std: datum.Std,
        NumClusterSamples: datum.NumClusterSamples,
        x: null,
        y: null,
        parentInd: null,
        depth: -1,
        rowIndex: 0,
        leftRightInfoList: []
      };
    });

    const nodesDict: NodesDict = _.keyBy(this.nodes, node => node.Ind);

    // parent를 구한다.
    _.forEach(this.nodes, node => {
      // console.log('node', nodesDict[node.Lind]);
      if (nodesDict.hasOwnProperty(node.Lind)) {
        nodesDict[node.Lind].parentInd = node.Ind;
      }
      if (nodesDict.hasOwnProperty(node.Rind)) {
        nodesDict[node.Rind].parentInd = node.Ind;
      }
    });
    // root를 구한다.
    const rootNode: Node = _.filter(
      this.nodes,
      node => node.parentInd === null
    )[0];

    rootNode.x = 5000;
    rootNode.y = 50;

    // 각 node마다 depth를 구한다.
    _.forEach(this.nodes, node => {
      node = this.makeNodeDepthAndLeftRightInfoList(node, nodesDict);
    });

    const maxDepthNode: Node = _.maxBy(this.nodes, node => node.depth) as Node;
    const maxDepth: number = maxDepthNode.depth as number;

    // node의 x, y 좌표를 찾는다.
    this.nodes = _.map(this.nodes, node => {
      return this.makeNodePosition(node, maxDepth);
    });

    this.nodes = _.values(nodesDict);

    // edges를 만든다.
    _.forEach(this.nodes, node => {
      if (node.Lind !== 0) {
        this.edges.push({
          x1: node.x as number,
          y1: node.y as number,
          x2: nodesDict[node.Lind].x as number,
          y2: nodesDict[node.Lind].y as number
        });
      }
      if (node.Rind !== 0) {
        this.edges.push({
          x1: node.x as number,
          y1: node.y as number,
          x2: nodesDict[node.Rind].x as number,
          y2: nodesDict[node.Rind].y as number
        });
      }
    });

    console.log('this.nodes', this.nodes);
    console.log('this.edges', this.edges);
  }

  private makeXPositionIndex(node: Node): number {
    let xPositionIndex: number = 0;
    _.forEach(node.leftRightInfoList, (info, index) => {
      if (index < node.leftRightInfoList.length - 1) {
        if (info === 'right') {
          xPositionIndex += Math.pow(
            2,
            node.leftRightInfoList.length - 1 - index
          );
        }
      } else {
        if (info === 'right') {
          xPositionIndex += 1;
        }
      }
    });

    return xPositionIndex;
  }

  private makeNodeDepthAndLeftRightInfoList(
    node: Node,
    nodesDict: NodesDict
  ): Node {
    let currentNode: Node = node;
    let depth: number = 0;
    const leftRightInfoList: string[] = [];

    while (currentNode.parentInd !== null) {
      depth += 1;
      const parentNode: Node = nodesDict[currentNode.parentInd];

      if (currentNode.Ind === parentNode.Lind) {
        leftRightInfoList.unshift('left');
      } else if (currentNode.Ind === parentNode.Rind) {
        leftRightInfoList.unshift('right');
      }

      currentNode = parentNode;
    }

    node.depth = depth;
    node.leftRightInfoList = leftRightInfoList;

    return node;
  }

  /**
   * 자식들 중 가장 깊은 depth를 반환하는 함수
   * @param node
   * @param nodesDict
   */
  private findChildMaxDepth(node: Node, nodesDict: NodesDict): number {
    let leftChildDepth: number = node.depth as number;
    let rightChildDepth: number = node.depth as number;
    if (node.Lind !== 0) {
      leftChildDepth = this.findChildMaxDepth(nodesDict[node.Lind], nodesDict);
    }
    if (node.Rind !== 0) {
      rightChildDepth = this.findChildMaxDepth(nodesDict[node.Rind], nodesDict);
    }

    return leftChildDepth >= rightChildDepth ? leftChildDepth : rightChildDepth;
  }

  private makeNodePosition(node: Node, maxDepth: number): Node {
    const xInterval: number =
      this.basicXInterval * Math.pow(2, maxDepth + 1 - node.depth);
    console.log('xInterval', xInterval);
    node.x = this.makeXPositionIndex(node) * xInterval + 0.5 * xInterval;
    node.y = (node.depth + 1) * this.nodeYInterval;

    return node;
  }

  private mounted() {
    //
  }
}
